'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { NavRail, type NavRailItem } from '@/components/ui/nav-rail';
import styles from './header.module.css';

interface Props {
  items: NavRailItem[];
}

/**
 * Primary nav — composes the shared NavRail (sliding active-pill). The active
 * item is derived from the current pathname; NavRail glides its pill to it and
 * fades the pill out on routes that aren't in the rail.
 */
export function HeaderNav({ items }: Props) {
  const pathname = usePathname();
  const t = useTranslations('nav');

  const active =
    items.find((it) => it.href && (pathname === it.href || pathname.startsWith(`${it.href}/`)))?.id ?? '';

  return (
    <nav className={styles.nav} aria-label={t('mainNavigation')}>
      <NavRail items={items} active={active} />
    </nav>
  );
}
